
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { ProjectReportData, EvaluationReportData, V2Project } from "@/store/admin/adminTypes";
import { buildCandidateSummaries, buildTraitGroups, CandidateSummary, TraitGroupDef } from "./shared";
import ComparisonGrid from "./ComparisonGrid.vue";
import CompetencySpread from "./CompetencySpread.vue";
import PrioritizationLegend from "./PrioritizationLegend.vue";
import CandidatePicker from "@/components/project-reports/CandidatePicker.vue";

@Component({
  components: {
    ComparisonGrid,
    CompetencySpread,
    PrioritizationLegend,
    CandidatePicker,
  },
})
export default class ComparisonTab extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true })
  readonly report!: ProjectReportData;

  @Prop({ required: true })
  readonly project!: V2Project;

  @Prop({ required: true })
  readonly reportData!: EvaluationReportData;

  @Prop({ required: true })
  readonly sortedAssessments!: EvaluationReportData["assessments"];

  @Prop({ default: false })
  readonly printing!: boolean;

  public view: "grid" | "spread" = "grid";
  public activeState: Record<string, boolean> = {};

  get summaries(): CandidateSummary[] {
    return buildCandidateSummaries(this.sortedAssessments, this.reportData);
  }

  get activeSummaries(): CandidateSummary[] {
    return this.summaries.filter((s) => this.activeState[s.id]);
  }

  get activeIds(): string[] {
    return this.activeSummaries.map((s) => s.id);
  }

  get traitGroups(): TraitGroupDef[] {
    return buildTraitGroups(this.reportData.traitPriorities ?? {});
  }

  toggleCandidate(id: string): void {
    this.$set(this.activeState, id, !this.activeState[id]);
  }

  created() {
    this.summaries.forEach((s) => this.$set(this.activeState, s.id, true));
  }
}
